<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { useCustomerStore } from '@stores/me/customer'

import { useAppBrand } from '@composables/tools/app-brand.hook'

import LinkDisciplineEla from '@Widgets/Menu/LinkDisciplineEla.vue'
import LinkDisciplineMath from '@Widgets/Menu/LinkDisciplineMath.vue'
import LinkStudentApp from '@Widgets/Menu/LinkStudentApp.vue'
import LinkPricing from '@Widgets/Menu/LinkPricing.vue'
import BtnSupport from '@Widgets/Menu/BtnSupport.vue'
import BtnMore from '@Widgets/Menu/BtnMore.vue'

defineOptions({
  name: 'HeaderMenu',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const store = useCustomerStore()

const { isSmartestMinds } = useAppBrand()
</script>

<template>
  <LinkDisciplineMath :layout="layout" />
  <LinkDisciplineEla :layout="layout" />
  <LinkStudentApp
    v-if="!isSmartestMinds"
    :layout="layout"
  />
  <LinkPricing
    v-if="store.isTypeDemo"
    view="menu-button"
    :layout="layout"
  />
  <BtnSupport
    v-else
    :layout="layout"
  />
  <BtnMore :layout="layout" />
</template>
